import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-72c22f5a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "content_list" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "content_list_item_title" }
const _hoisted_5 = {
  key: 0,
  class: "content_list_item_title_tips"
}
const _hoisted_6 = { class: "content_list_item_nr" }
const _hoisted_7 = { class: "content_list_item_nr_box" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "物料编码：", -1))
const _hoisted_9 = { class: "cr" }
const _hoisted_10 = { class: "content_list_item_nr_box" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "计划数量：", -1))
const _hoisted_12 = { class: "cr" }
const _hoisted_13 = { class: "content_list_item_nr_box" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "计划日期：", -1))
const _hoisted_15 = { class: "cr" }
const _hoisted_16 = { class: "content_list_item_nr_box" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "计划员：", -1))
const _hoisted_18 = { class: "cr" }
const _hoisted_19 = { class: "content_list_item_nr_box" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "生产批次：", -1))
const _hoisted_21 = { class: "cr" }
const _hoisted_22 = {
  key: 0,
  class: "content_list_item_nr_box"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "销售订单：", -1))
const _hoisted_24 = { class: "cr" }

import { reactive, ref, onBeforeUnmount, getCurrentInstance, onMounted } from "vue"
    import { useRouter, useRoute } from "vue-router"
    import { getList } from "@/apis/PlanningAPI"
    import { judgmentPlatform } from '@/utils/utils'

    
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

    const route = useRoute()
    const router = useRouter()

    let status = ref<boolean>(false)    // 根据平台是否需要设置top

    const { $Bus }  = getCurrentInstance().appContext.config.globalProperties 

    // 分页查询数据
    const pageData = reactive({
        capacity: 10,
        page: 0,
        total: 0,
        name: ''
    })

    // 列表数据
    let listData: any = ref([])
    const loading = ref(false)
    const finished = ref(false)
    const refreshing = ref(false)

    const clickItem = (obj: any) => {
        $Bus.emit('callback', obj)
        router.go(-1)
    }

    // 搜索提交
    const submit = (): void => {
        pageData.page = 0
        finished.value = false
        listData.value = []
        onLoad()
    }

    // 搜索框
    const searchInput = (data: any) => {
        pageData.name = data
        pageData.page = 0
        finished.value = false
        listData.value = []
        onLoad()
    }

    // 列表
    const onLoad = () => {
        if (!finished.value) {
            pageData.page = pageData.page + 1
            loading.value = true
            getList({
                capacity: pageData.capacity,
                page: pageData.page,
                model: {
                    mixParam: pageData.name,
                    statusList: [1, 4],
                    paused: 0
                },
                sorts: [
                    { direction: 'DESC', property: 'CREATE_TIME' }
                ]
            }).then(res => {
                if (refreshing.value) {
                    listData.value = []
                    refreshing.value = false;
                }
                loading.value = false
                if (res.code === 200 && res.data.records && res.data.records.length !== 0) {
                    pageData.total = res.data.total
                    listData.value.push(...res.data.records)
                } else {
                    finished.value = true
                }
            }).catch(err => {
                loading.value = false
                finished.value = true
                if (refreshing.value) {
                    listData.value = []
                    refreshing.value = false;
                }
            })
        }
    }

    // 下拉刷新优化页面
    const onRefresh = () => {
        finished.value = false;
        pageData.page = 0
        loading.value = true;
        onLoad();
    }

    onBeforeUnmount(() => {
        $Bus.all.delete("changeOdr")
    })

    onMounted(() => {
        status.value = judgmentPlatform()
    })

return (_ctx: any,_cache: any) => {
  const _component_v_Search = _resolveComponent("v-Search")!
  const _component_van_swipe_cell = _resolveComponent("van-swipe-cell")!
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass([{ 'content_top': _unref(status) }, "content_search"])
    }, [
      _createVNode(_component_v_Search, {
        onSearchInput: searchInput,
        onSubmit: submit,
        isShow: false,
        placeholder: "搜索物料名称/编码/工序名称"
      })
    ], 2),
    _createVNode(_component_van_pull_refresh, {
      modelValue: refreshing.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((refreshing).value = $event)),
      onRefresh: onRefresh
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_list, {
          loading: loading.value,
          "onUpdate:loading": _cache[0] || (_cache[0] = ($event: any) => ((loading).value = $event)),
          finished: finished.value,
          "finished-text": "没有更多了~",
          onLoad: onLoad
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(listData), (item, i) => {
                return (_openBlock(), _createBlock(_component_van_swipe_cell, { key: i }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: "content_list_item",
                      onClick: ($event: any) => (clickItem(item))
                    }, [
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("span", null, _toDisplayString(item.materialName) + "｜" + _toDisplayString(item.produceName), 1),
                        (item.urgent)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_5, "优先" + _toDisplayString(item.urgent), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                          _hoisted_8,
                          _createElementVNode("div", _hoisted_9, _toDisplayString(item.materialName) + "丨" + _toDisplayString(item.materialCode), 1)
                        ]),
                        _createElementVNode("div", _hoisted_10, [
                          _hoisted_11,
                          _createElementVNode("div", _hoisted_12, _toDisplayString(item.num) + _toDisplayString(item.umodel.name), 1)
                        ]),
                        _createElementVNode("div", _hoisted_13, [
                          _hoisted_14,
                          _createElementVNode("div", _hoisted_15, _toDisplayString(item.workPlanStartDate) + " ~ " + _toDisplayString(item.workPlanEndDate), 1)
                        ]),
                        _createElementVNode("div", _hoisted_16, [
                          _hoisted_17,
                          _createElementVNode("div", _hoisted_18, _toDisplayString(item.planUserName), 1)
                        ]),
                        _createElementVNode("div", _hoisted_19, [
                          _hoisted_20,
                          _createElementVNode("div", _hoisted_21, _toDisplayString(item.batch), 1)
                        ]),
                        (item.salesOrder)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                              _hoisted_23,
                              _createElementVNode("div", _hoisted_24, _toDisplayString(item.salesOrder), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ], 8, _hoisted_3)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ])
          ]),
          _: 1
        }, 8, ["loading", "finished"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})